// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"305":"3bf627fb","830":"a457f1a0"}[chunkId] + ".chunk.js";
};